import React, { Component } from 'react'
import { Upload, Button, message } from 'hljd'
import Sorter from './Sorter'
import { PlusOutlined, HolderOutlined, DeleteOutlined } from '@ant-design/icons'
import styles from './style.module.less'

export default class extends Component {
  constructor(props) {
    super(props)
    this.deleteItem = this.deleteItem.bind(this)
    this.addItem = this.addItem.bind(this)
    this.uploadChange = this.uploadChange.bind(this)
  }

  deleteItem(deleteIndex) {
    const { value, onChange } = this.props
    if (value.length <= 1) {
      message.error('最少保留1个场地布置案例')
    } else {
      const newValue = value.filter((item, index) => {
        return index !== deleteIndex
      })
      onChange(newValue)
    }
  }

  addItem() {
    const { value, onChange } = this.props
    const newValue = [...value]
    if (value.length >= 10) {
      message.error('最多可添加10个场地')
    } else {
      newValue.push([])
      onChange(newValue)
    }
  }

  beforeImageUpload = async (file, fileList) => {
    const { width } = await Upload.checkSizeSync(file)
    if (width < 540) {
      message.error('图片宽度不能小于540')
      return Promise.reject(file)
    }
    if (file.size > 20 * 1024 * 1024) {
      message.error('图片大小不能超过20M')
      return Promise.reject(file)
    }
    return Promise.resolve(file)
  }

  uploadChange(e, index) {
    const { value, onChange } = this.props
    const newValue = [...value]
    newValue[index] = e
    onChange(newValue)
  }

  render() {
    const { value, onChange } = this.props
    console.log('value', value)
    return (
      <div className={styles.caseItemContainer}>
        <Sorter
          onSortEnd={e => onChange(e)}
          data={value}
          render={(item, index) => (
            <div className={styles.item} key={index}>
              <div className={styles.content}>
                <HolderOutlined className={styles.icon} />
                <span style={{ width: '48px' }}>{`案例${index + 1}`}</span>
                <Upload
                  value={item}
                  listMode
                  onChange={e => this.uploadChange(e, index)}
                  max={10}
                  multiple
                  sortable
                  beforeUpload={this.beforeImageUpload}
                />
              </div>
              <div
                className={styles.btn}
                onClick={() => this.deleteItem(index)}
              >
                <DeleteOutlined className={styles.deleteBtn} />
              </div>
            </div>
          )}
        />
        <Button
          type="dashed"
          className={styles.addBtn}
          icon={<PlusOutlined />}
          onClick={this.addItem}
        >
          添加下一组案例
        </Button>
      </div>
    )
  }
}
